import React from "react";
import Grid from "@mui/material/GridLegacy";
import TextField from "@mui/material/TextField";
import {UseFormRegister} from "react-hook-form/dist/types/form";
import {FieldErrors} from "react-hook-form/dist/types/errors";

interface PhysicalAddressProps {
  register: UseFormRegister<any>;
  errors: FieldErrors<any>;
}

const BusinessInformation:React.FunctionComponent<PhysicalAddressProps> = ({
  register,
  errors,
  }) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6}>
        <TextField
          label="Bank Account Name"
          id="accountHolderName"
          fullWidth
          required
          helperText={errors.accountHolderName?.message?.toString()}
          {...register('accountHolderName')}
          error={!!errors.accountHolderName}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          label="Routing Number"
          id="routingNumber"
          fullWidth
          required
          helperText={errors.routingNumber?.message?.toString()}
          {...register('routingNumber')}
          error={!!errors.routingNumber}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          label="Account Number"
          id="accountNumber"
          fullWidth
          required
          helperText={errors.accountNumber?.message?.toString()}
          {...register('accountNumber')}
          error={!!errors.accountNumber}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          label="Confirm Account Number"
          id="confirmAccountNumber"
          fullWidth
          required
          helperText={errors.confirmAccountNumber?.message?.toString()}
          {...register('confirmAccountNumber')}
          error={!!errors.confirmAccountNumber}
        />
      </Grid>
    </Grid>
  )
}

export default BusinessInformation;